import './App.css';
// We just need BS for the grid mostly
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// dracula
import 'dracula-ui/styles/dracula-ui.css';
import { Card, Divider } from 'dracula-ui';

import Header from './components/Header.js';
import Socials from './components/Socials.js';
import Main from './components/Main.js';
import Footer from './components/Footer.js';

function App() {
  return (
    <Card 
      variant="subtle" 
      height="7xl" 
      p="md" 
      m="sm" 
      className="drac-border-white">
      <Container>
        <Header />
        <Divider />
        <Row>
          <Col md={4}>
            <Socials />
          </Col>
          <Col md={8}>
            <Main />
          </Col>
        </Row>
        <Footer />
      </Container>
    </Card>
  );
}

export default App;